export default __webpack_public_path__ + "static/media/button-sound.8277ab8c.mp3";